export default class TranslationHelper {
  static translateDay(day: string): string {
    const translations: Record<string, string> = {
      sunday: 'Domingo',
      monday: 'Segunda-feira',
      tuesday: 'Terça-feira',
      wednesday: 'Quarta-feira',
      thursday: 'Quinta-feira',
      friday: 'Sexta-feira',
      saturday: 'Sábado',
    }

    return translations[day] || day
  }

  static translateSchedule(schedule: string): string {
    const translations: Record<string, string> = {
      morning: 'Manhã',
      afternoon: 'Tarde',
      night: 'Noite',
    }

    return translations[schedule] || schedule
  }
}

export const errorsMessages: Record<string, string> = {
  'The request is invalid.subscription.card: The number field is not a valid card number':
    'O número do cartão é inválido.',
}
